import * as types from "./actionTypes";
import axios from "axios";
import config from "../../config";
import * as authHelpers from "../../authentication/authHelpers";
import { actionCreators as staticDataActions } from "./staticDataActions";

export const actionCreators = {
    loginWithProvider: (provider, ecrId, unlockCode) => async (dispatch) => {
        const accountUniqueName = authHelpers.getAccountUniqueNameFromUrl();

        try {
            const ecrIdStr = ecrId ?? '';
            const unlockCodeStr = unlockCode ?? ''

            const response = await axios.get(
                `${config.apiUrl}/api/access/${provider}/${accountUniqueName}/login-page?ecrId=${ecrIdStr}&unlockCode=${unlockCodeStr}`
            );

            const redirect = response.data;

            return redirect;
        } catch (error) {
            dispatch({
                type: types.authApiRequestError,
                error: error.response
                    ? error.response.data
                    : "Failed to login with provider.",
            });
        }
    },
    sendVerificationCode: (ecrId, unlockCode2) => async (dispatch) => {
        const accountUniqueName = authHelpers.getAccountUniqueNameFromUrl();

        try {
            await axios.post(
                `${config.apiUrl}/api/access/${accountUniqueName}/send-verification-code`,
                {
                    unlockCode2: unlockCode2.trim(), // the invite code, aka UnlockCode2
                    ecrId: ecrId
                }
            );
            return Promise.resolve();
        } catch (error) {
            dispatch({
                type: types.authApiRequestError,
                error: error.response
                    ? error.response.data
                    : "Failed to login as guest.",
            });
            return Promise.reject({ errorMessage: error?.response?.data?.ErrorMessage });
        }
    },
    signOut: () => async () => {
        try {
            await axios.post(`${config.apiUrl}/api/access/sign-out`, null);

            authHelpers.logout();

            return Promise.resolve();
        } catch (error) {
            return Promise.reject({ errorMessage: error?.response?.data?.ErrorMessage });
        }
    },
    verifyUser: (ecrId, unlockCode2, unlockCode) => async (dispatch) => {
        const accountUniqueName = authHelpers.getAccountUniqueNameFromUrl();

        try {
            const result = await axios.post(
                `${config.apiUrl}/api/access/${accountUniqueName}/verify-user`,
                {
                    ecrId: ecrId, // the verification code entered by the user, aka UnlockCode
                    unlockCode2: unlockCode2.trim(), // the invite code, aka UnlockCode2
                    unlockCode: unlockCode.trim()
                }
            );

            if (result && result.data) {
                var authUser = {
                    name: result.data.Name,
                    token: result.data.AccessToken,
                    accountName: accountUniqueName,
                    consent: result.data.consent,
                    configurationSettings: null
                }

                authHelpers.setAuthUser(authUser);

                const configurationSettings = await dispatch(staticDataActions.requestConfigurationSettings(accountUniqueName));

                authUser = {
                    ...authUser,
                    configurationSettings: configurationSettings
                };

                authHelpers.setAuthUser(authUser);

                return Promise.resolve();
            } else {
                return Promise.reject();
            }
        } catch (error) {
            return Promise.reject({ errorMessage: error?.response?.data?.ErrorMessage });
        }
    },
    getLegalText: (id) => async (dispatch) => {

        try {
            const response = await axios.get(
                `${config.apiUrl}/api/access/acceptance-of-terms/${id}`
            );

            if (response && response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject();
            }
        } catch (error) {
            return Promise.reject({ errorMessage: error?.response?.data?.ErrorMessage });
        }
    },
    checkUserConsent: () => async (dispatch) => {

        try {
            const response = await axios.get(
                `${config.apiUrl}/api/access/check-acceptance-of-terms`
            );

            if (response && response.data) {
                if (response.data.length == 0) {
                    authHelpers.setAuthUser({ ...authHelpers.getAuthUser(), consent: true });
                }
                return Promise.resolve(response.data);
            } else {
                return Promise.reject();
            }
        } catch (error) {
            return Promise.reject({ errorMessage: error?.response?.data?.ErrorMessage });
        }
    },
    updateUserConsent: (legalTextIDs) => async (dispatch) => {
        try {
            const response = await axios.post(`${config.apiUrl}/api/access/update-acceptance-of-terms`, legalTextIDs);

            if (response && response.status == 200) {
                authHelpers.setAuthUser({ ...authHelpers.getAuthUser(), consent: true });
                return Promise.resolve();
            } else {
                return Promise.reject();
            }
        } catch (error) {
            return Promise.reject({ errorMessage: error?.response?.data?.ErrorMessage });
        }
    },
    loginFail: () => async (dispatch) => { dispatch({ type: types.registerFail }) },
    resetUnlockCode: (userDetails) => async (dispatch) => {
        dispatch({ type: types.resetUnlockCode });
        try {
            await axios.post(`${config.apiUrl}/api/access/users/reset`, userDetails);
            dispatch({ type: types.resetUnlockCodeSuccess });
        } catch (error) {
            dispatch({ type: types.resetUnlockCodeError });
            if (error.message === 'Network Error') return;
            // TODO: handle error
            console.log(error);
            return { errorMessage: error.response?.data?.ErrorMessage };
        }
    },
    resetVerificationCode: (userDetails) => async (dispatch) => {
        dispatch({ type: types.resetVerificationCode });
        try {
            await axios.post(`${config.apiUrl}/api/access/users/reset-verification-code`, userDetails);
            dispatch({ type: types.resetVerificationCodeSuccess });
        } catch (error) {
            dispatch({ type: types.resetVerificationCodeError });

            var errorData = error.response.data

            return errorData.errorMessage ? errorData.errorMessage : errorData;
        }
    },
    checkAccountMismatch: (accessCode) => async (dispatch) => {
        const user = authHelpers.getAuthUser();
        const accountUniqueName = authHelpers.getAccountUniqueNameFromUrl();

        if (user && (user.accountName !== accountUniqueName || accessCode)) {
            var details = {
                accountUniqueName: accountUniqueName,
                accessCode: accessCode
            };

            var response = await axios.post(`${config.apiUrl}/api/access/users/validate-url`, details);

            if (response && response.status === 200 && response.data === false) {
                authHelpers.logout();
                return false;
            }
        }

        return true;
    }
};
